import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

const Container = (props) => {
  const { tag: Tag, children, className, ...attributes } = props;

  return (
    <Tag {...attributes} className={cn('container', className)}>
      {children}
    </Tag>
  );
};

Container.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  children: PropTypes.node,
  className: PropTypes.string,
};

Container.defaultProps = {
  tag: 'div',
  className: '',
};

export default Container;
